import { FC, useCallback } from 'react';
import { useIntl } from '@leagueplatform/locales';
import { EXTERNAL_SSO_LINK } from 'common/constants';
import { ContentProps } from 'models/profile-settings.model';
import { DetailSection } from './detail-section.component';

interface ContactInfoProps {
  primaryPhoneNumber: string;
  email: string;
}

export const ContactInfoComponent: FC<ContactInfoProps> = ({
  primaryPhoneNumber,
  email,
}) => {
  const { formatMessage } = useIntl();

  const contents: ContentProps[] = [
    {
      labelId: 'STR_PRIMARY_PHONE_NUMBER',
      value: primaryPhoneNumber,
      type: 'phone',
    },
    { labelId: 'STR_EMAIL', value: email, type: 'email' },
  ];

  const formatValue = useCallback(
    (value: string) => {
      // Show "Not provided" for empty values
      if (!value || value.trim() === '') {
        return formatMessage({ id: 'STR_NOT_PROVIDED' });
      }
      return value;
    },
    [formatMessage],
  );

  return (
    <DetailSection
      title="STR_CONTACT_INFORMATION"
      contents={contents}
      ssoUrl={EXTERNAL_SSO_LINK.PROFILE_SETTINGS_COMMUNICATION_INF0_SSO_LINK}
      formatValue={formatValue}
    />
  );
};
